import {
  GET_RESIDENT_LIST_KEY,
  useGetNursingHomeList,
  useServiceProviderAppApi,
} from '@pflegenavi/service-provider-frontend/api';
import { useQueryClient } from 'react-query';
import { useEffect } from 'react';

export const useInitializeResidents = (): void => {
  const serviceProviderAppApi = useServiceProviderAppApi();

  const { data } = useGetNursingHomeList();

  const queryClient = useQueryClient();

  useEffect(() => {
    if (!data) {
      return;
    }

    for (const nursingHome of data) {
      const key = GET_RESIDENT_LIST_KEY(
        nursingHome.tenant,
        nursingHome.nursingHomeId
      );
      queryClient.prefetchQuery({
        queryKey: key,
        queryFn: () =>
          serviceProviderAppApi.getResidentList({
            params: {
              tenant: nursingHome.tenant,
              nursingHomeId: nursingHome.nursingHomeId,
            },
          }),
        initialData: () => queryClient.getQueryData(key),
        initialDataUpdatedAt: () =>
          queryClient.getQueryState(key)?.dataUpdatedAt,
      });
    }
  }, [data, queryClient, serviceProviderAppApi]);
};
